import React from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import { ActivityLogs } from "../../activityLogs";
import { GetActivityLogs } from "../action";
import { DataType } from "constant";

import moment from "moment";

import { FirmwaresPath } from "routes/paths";

const FileActivityLogFilters = Object.freeze([
  {
    key: "FileName",
    value: "File Name",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "UserId", value: "User", dataType: DataType.String },
]);

const FirmwaresActivityLogs = ({ history, GetActivityLogs }) => {
  return (
    <div className="container-fluid">
      <h1>Firmwares</h1>
      <Row>
        <ActivityLogs
          hasActivityFilter
          onFetchActivityLogs={GetActivityLogs}
          onBackMainPage={() => history.push(FirmwaresPath)}
          activityLogFilters={FileActivityLogFilters}
          backButtonLabel={"View Firmwares"}
          extraColumns={[
            {
              dataField: "fileName",
              text: "File Name",
              sort: false,
              style: { wordWrap: "break-word" },
              headerStyle: { wordWrap: "break-word" },
              style: { wordWrap: "break-word" },
              headerStyle: { wordWrap: "break-word" },
              title: (cell) => cell,
            },
          ]}
          detailsModalHeader={[
            {
              label: "Filename",
              value: "fileName",
            },
            {
              label: "Activity",
              value: "activity",
            },
            {
              label: "User",
              value: "user",
            },
            {
              label: "Date",
              value: "date",
              formatter: (data) => moment(data).format("LLL"),
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default connect(() => {}, { GetActivityLogs })(FirmwaresActivityLogs);
